export function opener() {
  const openers = document.querySelectorAll(".js-opener");
  const openerBtns = document.querySelectorAll(".js-openerBtn");
  const openerCloses = document.querySelectorAll(".js-openerClose");

  openers.forEach((opener) => {
    opener.style.display = "none";
  })
  
  openerBtns.forEach(openerBtn => {
    openerBtn.addEventListener("click", () => {
      
      const theOpener = document.querySelector(openerBtn.dataset.target);

      if(openerBtn.classList.contains("is-opened")) {
        openerBtn.classList.remove("is-opened");
        theOpener.style.display = "none";
      } else {
        openerBtn.classList.add("is-opened");
        theOpener.style.display = "block";
      }      
    })
  })

  openerCloses.forEach(openerClose => {
    openerClose.addEventListener("click", () => {

      openerBtns.forEach(openerBtn => {
        openerBtn.classList.remove("is-opened");
      })

      openers.forEach(opener => {
        opener.style.display = "none";
      })
      
    })
  })
}
